<template>
  <div class="card card-custom card-stretch gutter-b">
    <div class="card-header border-0 py-5">
      <h3 class="card-title align-items-start flex-column">
        <span class="card-label font-weight-bolder text-dark">
          Novo Ambiente
        </span>
      </h3>
    </div>
    <Form url="/restaurante/ambientes/create" :ambiente="ambiente" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Form from "./Form.vue";
import AmbienteData from "./AmbienteData";

export default {
  name: "app-restaurante-ambientes-create",
  data() {
    return {
      ambiente: new AmbienteData({}),
    };
  },
  components: {
    Form,
  },
  computed: {
    ...mapGetters(["itsblocked"]),
  },
  mounted() {
    if (this.itsblocked) {
      this.$router.push({ name: "assinatura" });
    }
  },
};
</script>
